import { CreditCard } from "components/CreditCard"
import Form2MethodsPayment from "../Form2MethodsPayment"
import { PixMethod } from "../PixMethod"
import { DebitCardMethod } from "../DebitCardMethod"
import { CreditCard2Methods } from "../CreditCard2Methods"
import { EnumFormaPagamento } from "services"

export const paymentMethodsDict = {
  [EnumFormaPagamento.CREDITO]: CreditCard,
  [EnumFormaPagamento.DEBITO]: DebitCardMethod,
  [EnumFormaPagamento.PIX]: PixMethod,
  [EnumFormaPagamento.MULTIPLE]: Form2MethodsPayment,
  [EnumFormaPagamento.MULTIPLE_CREDIT]: CreditCard2Methods,
}

export const PAYMENT_METHOD_KEYS = {
  [EnumFormaPagamento.CREDITO]: "credit",
  [EnumFormaPagamento.DEBITO]: "debit",
  [EnumFormaPagamento.PIX]: "pix",
  [EnumFormaPagamento.MULTIPLE_CREDIT]: "credit",
}